class ThumbnailShowMore {
  constructor() {
    this.initShowMoreButtons();
  }

  initShowMoreButtons() {
    const showMoreBtns = document.querySelectorAll('.thumbnail-show-more-btn');
    
    showMoreBtns.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const wrapper = newBtn.closest('.thumbnail-wrapper');
        const thumbnailList = wrapper.querySelector('.thumbnail-list');
        
        const initialItems = parseInt(thumbnailList.dataset.initialItems) || 6;
        const isExpanded = thumbnailList.classList.contains('expanded');
        const allItems = thumbnailList.querySelectorAll('.thumbnail-list__item');
        
        if (!isExpanded) {
          allItems.forEach(item => {
            item.style.display = '';
          });
          thumbnailList.classList.add('expanded');
          if (newBtn.querySelector('.show-more-text')) {
            newBtn.querySelector('.show-more-text').style.display = 'none';
          }
          if (newBtn.querySelector('.show-less-text')) {
            newBtn.querySelector('.show-less-text').style.display = 'inline';
          }
        } else {
          allItems.forEach((item, index) => {
            if (index >= initialItems) {
              item.style.display = 'none';
            } else {
              item.style.display = '';
            }
          });
          thumbnailList.classList.remove('expanded');
          if (newBtn.querySelector('.show-more-text')) {
            newBtn.querySelector('.show-more-text').style.display = 'inline';
          }
          if (newBtn.querySelector('.show-less-text')) {
            newBtn.querySelector('.show-less-text').style.display = 'none';
          }
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ThumbnailShowMore();
  });
} else {
  new ThumbnailShowMore();
}

if (window.Shopify && (Shopify.designMode || Shopify.isPreview)) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.sectionId) {
      new ThumbnailShowMore();
    }
  });
}